const userTypes = {
  SET_CUSTOMERS: "SET_CUSTOMERS",
  SET_WARRIORS: "SET_WARRIORS",
  SET_BLOCKED_USERS: "SET_BLOCKED_USERS",
  UPDATE_WARRIOR: "UPDATE_WARRIOR",
  SET_GUEST_CUSTOMERS: "SET_GUEST_CUSTOMERS",
};

export default userTypes;
